import { useMatch } from 'react-router-dom';

import {
  HelpIcon,
  Layout,
  OverlayTriggerTooltip,
  Tabs as TabsComponent,
  Toolbar,
} from '@utilities';

import Page from '../Page';

import styles from './_index.module.scss';

interface TabsInterface {
  children: React.ReactNode;
  route: Route;
}

const Tabs = ({ children, route }: TabsInterface) => {
  const match = useMatch('/dashboard/:type/*');

  const routes = route?.routes;

  return (
    <Page>
      <Layout.Column className={styles['tabs']}>
        <Toolbar
          tools={[
            ...(route?.help_url
              ? [
                  // @ts-ignore
                  <OverlayTriggerTooltip aria-label="Help" content="Help">
                    <a
                      data-testid="help-link-button"
                      href={route?.help_url}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <HelpIcon />
                    </a>
                  </OverlayTriggerTooltip>,
                ]
              : []),
          ]}
        >
          <h1>{route?.headline}</h1>
        </Toolbar>
        {/* @ts-ignore */}
        <TabsComponent
          routes={routes?.map((route) => {
            return {
              ...route,
              to: `${match?.pathnameBase}/${route?.id}`,
            };
          })}
        />
        {children}
      </Layout.Column>
    </Page>
  );
};

export default Tabs;
